import React from 'react'
import ModalInformativo from '../generales/ModalInformativo'
import TablaGeneral from './TablaGeneral'
import moment from 'moment'

const ModalTabGeneral = ({setModalAbierto,modalAbierto,titulo, fSelect, actualizar, setActualizar,
    setTotalPerfil,  setArregloColor,setListMun, listMun, listReferente,
    nombre, edo, setListGeoEdo, contadorTotal, setTotalSecc, listPlantilla
}) => {
    const fInicio=moment(fSelect.inicio).format("DD/MM/YYYY");
    const fFinal=moment(fSelect.final).format("DD/MM/YYYY");   
    return (
    <ModalInformativo
        setModalAbierto={setModalAbierto}  
        modalAbierto={modalAbierto}  titulo={`Lista de Promovidos de ${fInicio} a ${fFinal}`}
        tamanio='lg'  
    >
        <TablaGeneral fSelect={fSelect} actualizar={actualizar} setActualizar={setActualizar}
        setTotalPerfil={setTotalPerfil} setArregloColor={setArregloColor}
        setListMun={setListMun} listMun={listMun} listReferente={listReferente}
        nombre={nombre} edo={edo} setListGeoEdo={setListGeoEdo}
        contadorTotal={contadorTotal} setTotalSecc={setTotalSecc} listPlantilla={listPlantilla}     
      />
            
    </ModalInformativo>
    )
}

export default ModalTabGeneral